import React, { useContext, useMemo } from 'react';

const Context = React.createContext({
	componentName: 'root',
	locationInPage: 'root',
});

export function useAnalyticsContext(){
	return useContext(Context);
}

export default function AnalyticsContext(props){
	const {componentName, children, type, ...rest} = props;
	const parent = useContext(Context);
	const value = useMemo(() => {
		return {
			componentName,
			get locationInPage(){
				return [parent?.locationInPage ?? 'root',componentName].join('-');
			}
		};
	}, [componentName, parent]);
	const body = type == null ? children : React.createElement(type, rest, children);
	return <Context.Provider value={value}>
		{body}
	</Context.Provider>
}